import { DataGrid, GridOverlay } from '@mui/x-data-grid';
import styled from 'styled-components';
import AppCSS from '../../utils/styled';
import { Pagination, TextField } from '@mui/material';

export const Components = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
  `,
  TableWrapper: styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    width: 100%;
  `,
  Table: styled(DataGrid)`
    border: none !important;
    ${AppCSS.fonts.label14Regular};
    color: ${AppCSS.colors.black} !important;
    & .MuiDataGrid-main {
      border: none !important;
      overflow: hidden;
    }
    & .MuiDataGrid-cell {
      background-color: ${AppCSS.colors.white};
      ${AppCSS.fonts.label14Regular};
      color: ${AppCSS.colors.black};
      border-bottom: 1px solid ${AppCSS.colors.utility.table.border} !important;
      &:focus {
        outline: none !important;
      }
      &:focus-visible,
      &:focus-within:has(:focus-visible) {
        outline: 2px solid ${AppCSS.colors.blues.primary} !important;
        outline-offset: -2px;
      }
    }
    & .MuiDataGrid-checkboxInput {
      color: ${AppCSS.colors.greys.light};
      width: 20px;
      height: 20px;
    }
    & .Mui-checked {
      color: ${AppCSS.colors.blues.dark} !important;
    }
    & .MuiDataGrid-columnHeader {
      ${AppCSS.fonts.label12Bold};
      color: ${AppCSS.colors.greys.prettyDark};
      background-color: transparent;
    }

    & .MuiDataGrid-columnsContainer {
      border: none;
      flex-direction: row !important;
    }
    & .MuiDataGrid-columnHeaders {
      border: none;
      border-bottom: 1px solid ${AppCSS.colors.utility.table.border};
      background-color: ${AppCSS.colors.utility.table.headerBackground};
    }
    & .MuiDataGrid-iconSeparator {
      display: none;
    }
    & .MuiDataGrid-columnHeader {
      &:focus {
        outline: none !important;
      }
      &:focus-visible {
        outline: 2px solid ${AppCSS.colors.blues.primary} !important;
        outline-offset: -2px;
      }
    }
    & .MuiDataGrid-row:last-child > .MuiDataGrid-cell {
      border-bottom: 0 !important;
    }
    & .MuiDataGrid-row:hover > div {
      background-color: ${AppCSS.colors.utility.table.rowHover};
    }
    & .MuiDataGrid-row.Mui-selected > div {
      background-color: ${AppCSS.colors.blues.veryLight};
    }
  `,
  TablePaginationContainer: styled.div<{ alternativeBackground?: boolean }>`
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-end;
    background-color: ${({ alternativeBackground }) =>
      alternativeBackground ? AppCSS.colors.greys.light : AppCSS.colors.white};
    padding: 12px 16px;
    margin-top: 8px;
    ${AppCSS.radiuses.default};
  `,
  PaginationLeftContainer: styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
  `,
  PaginationText: styled.span`
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.blues.dark};
  `,

  PaginationRightContainer: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  TablePagination: styled(Pagination)`
    & .MuiPaginationItem-outlined {
      color: ${AppCSS.colors.blues.darker};
      border: none;
      &:hover {
        background-color: ${AppCSS.colors.blues.veryLight};
      }
    }
    .Mui-selected {
      color: ${AppCSS.colors.white};
      border: 1px solid ${AppCSS.colors.blues.dark};
      background-color: ${AppCSS.colors.blues.dark} !important;
    }
  `,
  PaginationNavigation: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 12px;
    gap: 12px;
  `,
  PaginationNavigationButton: styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 8px;
    ${AppCSS.radiuses.small};
    &:hover {
      cursor: pointer;
      background-color: ${AppCSS.colors.blues.veryLight};
    }
  `,
  PaginationNavigationButtonText: styled.span`
    ${AppCSS.fonts.label12Bold};
    color: ${AppCSS.colors.blues.darker};
    margin-right: 4px;
  `,
  NavigationIconWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
  `,
  NavigationText: styled.span`
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.blues.darker};
  `,
  NavigationInput: styled(TextField)`
    background-color: ${AppCSS.colors.white};
    width: 48px;
    & .MuiOutlinedInput-root {
      ${AppCSS.fonts.label12Bold};
      color: ${AppCSS.colors.blues.veryDark};
      & .MuiOutlinedInput-input {
        text-align: center;
      }
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    input[type='number'] {
      -moz-appearance: textfield;
    }
  `,
  NavigationSeparator: styled.div`
    height: 24px;
    width: 1px;
    background-color: ${AppCSS.colors.blues.veryLight};
  `,
  SelectButton: styled.div<{ isFocused: boolean }>`
    display: flex;
    width: 56px;
    height: 30px;
    border: 1px solid ${(p) => (p.isFocused ? AppCSS.colors.blues.darker : AppCSS.colors.greys.light)};
    padding: 8px 12px;
    ${AppCSS.radiuses.small};
    margin-right: 8px;
    margin-left: 8px;
    &:hover {
      cursor: pointer;
    }
  `,
  TextButton: styled.span`
    ${AppCSS.fonts.h6};
    color: ${AppCSS.colors.blues.veryDark};
    align-self: center;
  `,
  IconWrapper: styled.div`
    margin-left: 8px;
    align-items: center;
    display: flex;
    justify-content: center;
  `,
  PlaceholderWrapper: styled(GridOverlay)`
    width: 100%;
  `,

  ItemsCountWrapper: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 12px;
    background-color: ${AppCSS.colors.white};
    padding: 8px;
    margin-bottom: 8px;
    ${AppCSS.radiuses.small}
  `,
  ItemsCountText: styled.span`
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.blues.dark};
  `,
};
